import { LandingFaq, LandingFeature, PlatformCard, ServerCard } from './landing.schemas';

export const features: LandingFeature[] = [
  {
    icon: 'zap',
    title: 'Быстрое подключение ⚡️',
    text: 'Выберите тариф, добавьте конфиг и меняйте локацию без сложной настройки.',
  },
  {
    icon: 'server',
    title: 'Стабильные серверы',
    text: 'Низкая задержка для повседневной работы, видео, мессенджеров и поездок.',
  },
  {
    icon: 'shield',
    title: 'Приватный доступ',
    text: 'Защищенный протокол, аккуратный кабинет и минимум лишних действий.',
  },
];

export const steps = ['Открываете MifVPN', 'Выбираете тариф', 'Подключаете устройство', 'Пользуетесь'];

export const platforms: PlatformCard[] = [
  { icon: 'phone', name: 'iPhone / iPad', hint: 'v2rayTun import' },
  { icon: 'phone', name: 'Android', hint: 'клиент и конфиг' },
  { icon: 'monitor', name: 'Windows', hint: 'копирование конфига' },
  { icon: 'linux', name: 'Linux', hint: 'ручной импорт' },
];

export const servers: ServerCard[] = [
  { icon: '🇫🇮', code: 'FN', label: 'Финляндия', tone: 'green' },
  { icon: '🇳🇱', code: 'NL', label: 'Нидерланды', tone: 'green' },
  { icon: '🤖', code: 'AI', label: 'ChatGPT', tone: 'cyan' },
  { icon: '🎬', code: 'YT', label: 'YouTube', tone: 'green' },
  { icon: '📞', code: 'WA', label: 'WhatsApp', tone: 'green' },
  { icon: '🔵', code: 'DS', label: 'Discord', tone: 'cyan' },
  { icon: '🎵', code: 'TT', label: 'TikTok', tone: 'green' },
  { icon: '📄', code: 'WL', label: 'Белый Лист', latency: 'скоро', tone: 'muted' },
];

export const faqs: LandingFaq[] = [
  {
    question: 'Как быстро я смогу подключиться?',
    answer: 'Обычно достаточно выбрать тариф, открыть страницу подключения и импортировать конфиг в клиент.',
  },
  {
    question: 'Можно ли использовать на нескольких устройствах?',
    answer: 'Да, в кабинете предусмотрены устройства и лимиты. Точные условия зависят от тарифа.',
  },
  {
    question: 'Что делать, если VPN не работает?',
    answer: 'На странице помощи будут инструкции, смена устройства и быстрый переход в поддержку.',
  },
];
